import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";

const controller = rpcController("ClienteDeCliente");

export const ClienteDeCliente = cacheResource({

    ObtenerClienteFinales: async (idCliente: number): Promise<models.ClienteDeClienteDTO[]> => await controller("ObtenerClienteFinales", { idCliente }),

    ClientesFinalesPuedeAgregar: async (idCliente: number, filtro: models.FiltroCliente): Promise<models.ClienteViewDTO[]> => await controller("ClientesFinalesPuedeAgregar", { idCliente }, filtro),

    Add: async (idCliente: number, idClientes: number[]): Promise<void> => await controller("Add", { idCliente }, idClientes),

    Delete: async (id: number): Promise<void> => await controller("Delete", { id }),

},
    {
        ObtenerClienteFinales: true,
        ClientesFinalesPuedeAgregar: true,
    }, {
        Add: true,
        Delete: true
    });



// WEBPACK FOOTER //
// ./app/resources/items/clientedecliente.ts